<template>
    <v-container fluid>
        <v-col>
            <v-row justify="center">{{Data}}</v-row>
            <v-row justify="center"><p class="text-center">{{Title}}</p></v-row>
        </v-col>
    </v-container>
</template>

<script>
export default {
    props:["Data", "Title"]
}
</script>